import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { ButtonEdit } from "@/components/ui/button";
import { getInitials, getProfilePictureUrl } from "@/lib/utils";
import { useModal } from "@/lib/hooks";
import DataTable, { Column } from "@/components/ui/DataTable";
import { useLazyGetRestaurantsQuery } from "@/redux/services/restaurant/restaurant.api";
import { Restaurant } from "@/redux/services/restaurant/restaurant.type";
import AddRestaurantModal from "../modals/AddRestaurantModal";
import { useEffect } from "react";
import { useAppSelector } from "@/redux/features/hooks";
import { Roles } from "@/redux/services/user/user.type";

const statusLabels: Record<string, { label: string; className: string }> = {
  active: {
    label: "Actif",
    className: "bg-accent-light text-accent",
  },
  inactive: {
    label: "Inactif",
    className: "bg-muted text-muted-foreground",
  },
  demo: {
    label: "Demo",
    className: "bg-orange-50 text-orange-600",
  },
};

const ListeRestaurants = () => {
  const { currentUser } = useAppSelector((state) => state.user);
  const [fetch, { data, isLoading }] = useLazyGetRestaurantsQuery();
  const { isOpen, item, closeModal, openEditModal } = useModal<Restaurant>();

  useEffect(() => {
    if (currentUser?.roles.includes(Roles.owner)) {
      fetch();
    }
  }, []);

  const columns: Column[] = [
    {
      key: "name",
      label: "Nom",
      formatter: (_value: any, row: any) => {
        const item = row as Restaurant;
        return (
          <div className="flex items-center gap-3">
            <Avatar className="h-8 w-8">
              <AvatarImage
                src={getProfilePictureUrl(item?.image?.url)}
                alt="avatar"
              />
              <AvatarFallback className="text-xs">
                {getInitials(item?.name)}
              </AvatarFallback>
            </Avatar>
            <span className="font-medium">{item?.name}</span>
          </div>
        );
      },
    },
    {
      key: "address",
      label: "Adresse",
      formatter: (_value: any, row: any) => (row as Restaurant)?.address || "-",
    },
    {
      key: "status",
      label: "Statut",
      formatter: (_value: any, row: any) => {
        const item = row as Restaurant;
        const status = statusLabels[item.status] ?? statusLabels.inactive;
        return (
          <span className={`text-xs font-medium px-2 py-1 rounded-full ${status.className}`}>
            {status.label}
          </span>
        );
      },
    },
    {
      key: "actions",
      label: "Actions",
      formatter: (_value: any, row: any) => {
        const item = row as Restaurant;
        return (
          <div className="flex items-center gap-3">
            {/* No delete here: DELETE /restaurants/{id} is ROLE_ADMIN only,
                and this tab is the owner's (SFRESTO-139). */}
            <ButtonEdit onClick={() => openEditModal(item)} />
          </div>
        );
      },
    },
  ];

  return (
    <>
      <DataTable
        data={data ?? []}
        columns={columns}
        loading={isLoading}
        totalCount={data?.length ?? 0}
        searchable={false}
        emptyMessage="Aucun restaurant trouvé"
      />
      {isOpen && (
        <AddRestaurantModal item={item} isOpen={isOpen} onClose={closeModal} />
      )}
    </>
  );
};

export default ListeRestaurants;
